<af-main-container #mainContainer
                   [title]="'i18n_af_labelIncidentTransactionIndex' | translate :{index: transactionId}"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   [filterNavigationPath]="Path.TRANSACTIONS"
                   [tabPathToTab]="tabPathToTab"
                   [queryParamsHandling]="'merge'"
                   spinnerIds="initial">
    <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        @if (authHolderService.hasAccess(['npck-admin']) && transaction?.isDeletable && !incident?.isInnocentStatus) {
            <ui-kit-button color="accent"
                           type="secondary"
                           [label]="'i18n_af_buttonDelete' | translate"
                           (clickListener)="deleteTransaction()"/>
        }
        @if (canEditTransaction) {
            <ui-kit-button [label]="'i18n_af_buttonEdit' | translate"
                           (clickListener)="editTransaction()"/>
        }
    </div>
    @if (transaction && incident) {
        <af-transaction class="w-100 mt-24 overflow-y-scroll"
                        [transaction]="transaction"
                        [incidentTypeCode]="incident.typeCode"
                        [isExpanded]="true"
                        [index]="transactionId"/>
    }
</af-main-container>
